import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float, ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { context } from '@adornis/baseql/server/context.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';
import { NotLoggedInError } from '@adornis/users/db/errors.js';

@Entity()
export class ResumeReviewResult extends AdornisEntity {
  static override _class = 'ResumeReviewResult';

  constructor(doc: PartialEntityData<ResumeReviewResult>) {
    super(doc);
  }

  @Field(() => Float)
  overallScore: Maybe<number>;

  @Field(() => Float)
  completenessScore: Maybe<number>;

  @Field(() => Float)
  structureScore: Maybe<number>;

  @Field(() => Float)
  contentScore: Maybe<number>;

  @Field(() => Float)
  clarityScore: Maybe<number>;

  @Field(() => String)
  summary: Maybe<string>;
}

@Entity()
export class ResumeFile extends AdornisFile {
  static override _class = 'ResumeFile';

  /** The session user that uploaded this resume. */
  @Field(() => ID)
  ownerID: Maybe<string>;

  @Field(() => String)
  reviewResultFileId: Maybe<string>;

  @Field(() => ResumeReviewResult)
  reviewResult: Maybe<ResumeReviewResult>;

  @Field(() => Boolean)
  extractedProfileData: Maybe<boolean>;

  static override beforeCreate(entity: ResumeFile): Promise<void> {
    if (!context.serverContext) {
      if (!context.userID) throw new NotLoggedInError();
      entity.ownerID = context.userID;
    }
    return super.beforeCreate(entity);
  }
}
